export default "__VITE_ASSET__e6bd8240__"